import { Injectable } from '@angular/core';
import { Action, select, Store } from '@ngrx/store';
import * as fromOrders from './orders.reducer';
import * as OrdersSelectors from './orders.selectors';

@Injectable()
export class OrdersFacade {
  loaded$ = this.store.pipe(select(OrdersSelectors.getOrdersLoaded));
  allOrders$ = this.store.pipe(select(OrdersSelectors.getAllOrders));

  selectedOrders$ = this.store.pipe(select(OrdersSelectors.getSelected));

  locations$ = this.store.pipe(select(OrdersSelectors.getLocations));
  addingOrUpdatingEvent$ = this.store.pipe(
    select(OrdersSelectors.getAddingOrUpdatingEvent)
  );

  selectedLocationType$ = this.store.pipe(
    select(OrdersSelectors.getLocationType)
  );

  selectedOrderDirection$ = this.store.pipe(
    select(OrdersSelectors.getOrderDirection)
  );

  selectedLocationIds$ = this.store.pipe(
    select(OrdersSelectors.getSelectedLocationIds)
  );

  selectedCustomerIds$ = this.store.pipe(
    select(OrdersSelectors.getSelectedCustomerIds)
  );

  selectedDateRange$ = this.store.pipe(
    select(OrdersSelectors.getSelectedDateRange)
  );

  ordersError$ = this.store.pipe(select(OrdersSelectors.getOrdersError));

  handShake$ = this.store.pipe(select(OrdersSelectors.getOrderHandShake));

  dateRange$ = this.store.pipe(select(OrdersSelectors.getSelectedLocationIds));

  query$ = this.store.pipe(select(OrdersSelectors.getQuery));
  nextPage$ = this.store.pipe(select(OrdersSelectors.getNextPage));
  messages$ = this.store.pipe(select(OrdersSelectors.messages));
  selectedStatus$ = this.store.pipe(select(OrdersSelectors.getStatus));

  constructor(private store: Store<fromOrders.OrdersPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
